import React from "react";

function WhatIsCryLPad() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is a Crypto Launchpad ?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  A crypto launchpad is a platform that enables blockchain
                  projects to raise capital by offering early-stage token sales
                  to investors, often at a discounted price before the token is
                  publicly available on exchanges. Launchpads are typically used
                  for Initial DEX Offerings (IDOs), Initial Coin Offerings
                  (ICOs), or other token sale models.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhatIsCryLPad;
